import { useT } from "../../i18n/LanguageContext";

export default function Testimonials() {
    const { t } = useT();
    const quotes = t("testimonials.items");

    return (
        <section
            data-testid="testimonials-section"
            className="py-24 md:py-32 lg:py-40"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="reveal mb-16 md:mb-20">
                    <p className="overline mb-6">{t("testimonials.overline")}</p>
                    <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[1.05] text-ink max-w-4xl">
                        {t("testimonials.headlineA")}{" "}
                        <em className="italic font-light text-terracotta">
                            {t("testimonials.headlineEm")}
                        </em>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--border-warm)] border border-warm">
                    {quotes.map((q, i) => (
                        <figure
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className="reveal bg-[var(--sand)] p-8 md:p-12 flex flex-col"
                        >
                            <span
                                aria-hidden
                                className="font-serif text-terracotta text-7xl leading-none mb-4"
                            >
                                &ldquo;
                            </span>
                            <blockquote className="font-serif text-2xl md:text-[1.6rem] leading-snug text-ink">
                                {q.body}
                            </blockquote>
                            <figcaption className="mt-auto pt-10 border-t border-warm">
                                <div className="text-sm text-ink">{q.author}</div>
                                <div className="text-xs uppercase tracking-[0.18em] text-secondary mt-1">
                                    {q.place}
                                </div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
